// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file platform/websocket/wsevent/v1/websocket.proto (package platform.websocket.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { PingResponse } from "./ping_pb.js";
import { AuthResponse } from "./auth_pb.js";
import { WebsocketResponse as WebsocketResponse$1 } from "../../../../securities/trm/core/portfolio/wsevent/v1/securities_pb.js";

/**
 * WebsocketRequest handles request for communicating via websocket
 *
 * @generated from message platform.websocket.wsevent.v1.WebsocketRequest
 */
export const WebsocketRequest = /*@__PURE__*/ proto3.makeMessageType(
  "platform.websocket.wsevent.v1.WebsocketRequest",
  () => [
    { no: 1, name: "requests", kind: "message", T: WebsocketRequest_Request, repeated: true },
  ],
);

/**
 * @generated from message platform.websocket.wsevent.v1.WebsocketRequest.Request
 */
export const WebsocketRequest_Request = /*@__PURE__*/ proto3.makeMessageType(
  "platform.websocket.wsevent.v1.WebsocketRequest.Request",
  () => [
    { no: 1, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "command", kind: "enum", T: proto3.getEnumType(WebsocketRequest_Request_Command), oneof: "action" },
    { no: 3, name: "subscribe", kind: "enum", T: proto3.getEnumType(WebsocketRequest_Request_Channel), oneof: "action" },
    { no: 4, name: "unsubscribe", kind: "enum", T: proto3.getEnumType(WebsocketRequest_Request_Channel), oneof: "action" },
  ],
  {localName: "WebsocketRequest_Request"},
);

/**
 * @generated from enum platform.websocket.wsevent.v1.WebsocketRequest.Request.Command
 */
export const WebsocketRequest_Request_Command = /*@__PURE__*/ proto3.makeEnum(
  "platform.websocket.wsevent.v1.WebsocketRequest.Request.Command",
  [
    {no: 0, name: "COMMAND_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "COMMAND_PING", localName: "PING"},
    {no: 2, name: "COMMAND_AUTH", localName: "AUTH"},
  ],
);

/**
 * @generated from enum platform.websocket.wsevent.v1.WebsocketRequest.Request.Channel
 */
export const WebsocketRequest_Request_Channel = /*@__PURE__*/ proto3.makeEnum(
  "platform.websocket.wsevent.v1.WebsocketRequest.Request.Channel",
  [
    {no: 0, name: "CHANNEL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CHANNEL_SECURITIES_LIVE_PORTO", localName: "SECURITIES_LIVE_PORTO"},
  ],
);

/**
 * WebsocketResponse handles response for communicating via websocket
 *
 * @generated from message platform.websocket.wsevent.v1.WebsocketResponse
 */
export const WebsocketResponse = /*@__PURE__*/ proto3.makeMessageType(
  "platform.websocket.wsevent.v1.WebsocketResponse",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "ping", kind: "message", T: PingResponse, oneof: "response" },
    { no: 3, name: "auth", kind: "message", T: AuthResponse, oneof: "response" },
    { no: 4, name: "securities", kind: "message", T: WebsocketResponse$1, oneof: "response" },
  ],
);

